import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "rounded border p-10" }
const _hoisted_3 = {
  id: "kt_carousel_1_carousel_pc",
  class: "carousel carousel-custom slide",
  "data-bs-ride": "carousel",
  "data-bs-interval": "1000"
}
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between flex-wrap" }
const _hoisted_5 = { class: "carousel-inner pt-8 text-center" }
const _hoisted_6 = { class: "carousel-item active" }
const _hoisted_7 = { class: "carousel-item" }
const _hoisted_8 = { class: "carousel-item" }
const _hoisted_9 = { class: "carousel-item" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-12\"><ol class=\"p-0 m-0 carousel-indicators carousel-indicators-dots\"><li data-bs-target=\"#kt_carousel_1_carousel_pc\" data-bs-slide-to=\"0\" class=\"ms-1 active\"></li><li data-bs-target=\"#kt_carousel_1_carousel_pc\" data-bs-slide-to=\"1\" class=\"ms-1\"></li><li data-bs-target=\"#kt_carousel_1_carousel_pc\" data-bs-slide-to=\"2\" class=\"ms-1\"></li><li data-bs-target=\"#kt_carousel_1_carousel_pc\" data-bs-slide-to=\"3\" class=\"ms-1\"></li></ol></div>", 1)
const _hoisted_11 = {
  id: "kt_mobile_carousel_1_carousel",
  class: "carousel carousel-custom slide",
  "data-bs-ride": "carousel",
  "data-bs-interval": "1000"
}
const _hoisted_12 = { class: "d-flex align-items-center justify-content-between flex-wrap row" }
const _hoisted_13 = { class: "carousel-inner pt-8 text-center" }
const _hoisted_14 = { class: "carousel-item active" }
const _hoisted_15 = { class: "carousel-item" }
const _hoisted_16 = { class: "carousel-item" }
const _hoisted_17 = { class: "carousel-item" }
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"col-xxl-12\"><ol class=\"p-0 m-0 carousel-indicators carousel-indicators-dots\"><li data-bs-target=\"#kt_mobile_carousel_1_carousel\" data-bs-slide-to=\"0\" class=\"ms-1 active\"></li><li data-bs-target=\"#kt_mobile_carousel_1_carousel\" data-bs-slide-to=\"1\" class=\"ms-1\"></li><li data-bs-target=\"#kt_mobile_carousel_1_carousel\" data-bs-slide-to=\"2\" class=\"ms-1\"></li><li data-bs-target=\"#kt_mobile_carousel_1_carousel\" data-bs-slide-to=\"3\" class=\"ms-1\"></li></ol></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("img", {
                src: _ctx.policyActivationPC,
                alt: "Image0",
                class: "mb-3",
                style: {"max-height":"350px !important","padding-right":".35%"}
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("img", {
                src: _ctx.over65YrsOldPC,
                alt: "Image1",
                class: "mb-3",
                style: {"max-height":"350px !important","padding-left":".35%"}
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("img", {
                src: _ctx.readYourInsurancePC,
                alt: "Image2",
                class: "mb-3",
                style: {"max-height":"350px !important","padding-right":".35%"}
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("img", {
                src: _ctx.repatcarePolicySigningPC,
                alt: "Image3",
                style: {"max-height":"350px !important","padding-left":".35%"},
                class: "mb-3"
              }, null, 8, ["src"])
            ])
          ]),
          _hoisted_10
        ])
      ], 512), [
        [_vShow, _ctx.isMobile == false]
      ]),
      _withDirectives(_createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("img", {
                src: _ctx.policyActivationMobile,
                alt: "Image0",
                style: {"max-height":"300px !important"},
                class: "mb-3"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_15, [
              _createVNode("img", {
                src: _ctx.over65YrsOldMobile,
                alt: "Image1",
                style: {"max-height":"300px !important"},
                class: "mb-3"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_16, [
              _createVNode("img", {
                src: _ctx.readYourInsuranceMobile,
                alt: "Image2",
                style: {"max-height":"300px !important"},
                class: "mb-3"
              }, null, 8, ["src"])
            ]),
            _createVNode("div", _hoisted_17, [
              _createVNode("img", {
                src: _ctx.repatcarePolicySigningMobile,
                alt: "Image3",
                style: {"max-height":"300px !important"},
                class: "mb-3"
              }, null, 8, ["src"])
            ])
          ]),
          _hoisted_18
        ])
      ], 512), [
        [_vShow, _ctx.isMobile == true]
      ])
    ])
  ]))
}